
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 57.85 50.57',
            'width': '44',
            'height': '44',
            'key': '1740'
        }, _createElement('path', {
            'fill': '#ffffff',
            'd': 'M44.62,27.09l-.33-1.22h3.84l-.72-4.65-8.87-1.14-6.63-8.4h-15.18l-4.47,3.54-1.07,5.18h-2.97v5.36h2.6l.57,1.69c-2.25.83-3.86,3-3.86,5.54,0,3.26,2.65,5.9,5.9,5.9s5.9-2.65,5.9-5.9c0-.33-.03-.65-.08-.96l2.31-.29v.94c0,.8.65,1.45,1.45,1.45h6.88c.51,0,.99-.27,1.25-.71l.56-.95h5.17l.14-.71,1.55.32c-.05.3-.07.6-.07.92,0,3.26,2.65,5.9,5.9,5.9s5.9-2.65,5.9-5.9-2.53-5.79-5.7-5.9ZM35.9,20.22l-2.82,2.29-9.48-.3-2.54-1.57,1.16-6.79h8.65l5.04,6.37ZM14.21,16.42l3.27-2.58h2.55l-1.12,6.56h-5.52l.82-3.98ZM12.56,25.74c1.45-.12,2.7,0,3.76.29l-.95,1.38c-.61-.21-1.26-.32-1.93-.32-.14,0-.28,0-.42.02l-.46-1.36ZM13.44,35.61c-1.45,0-2.62-1.18-2.62-2.62s1.18-2.62,2.62-2.62,2.62,1.18,2.62,2.62-1.18,2.62-2.62,2.62ZM17.73,28.94l1.2-1.62c.98.75,1.72,1.72,2.31,2.79l-2.48.31c-.26-.55-.61-1.05-1.02-1.48ZM39.07,30.49l-1.72-.36c.71-1.88,2.54-3.44,4.29-4.07l.47,1.49c-1.34.57-2.43,1.62-3.05,2.94ZM44.42,35.61c-1.45,0-2.62-1.18-2.62-2.62s1.18-2.62,2.62-2.62,2.62,1.18,2.62,2.62-1.18,2.62-2.62,2.62Z'
        }))], this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '1297'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1396'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]